"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressServiceStub = void 0;
class AddressServiceStub {
    getPostcodeData(postcode) {
        return __awaiter(this, void 0, void 0, function* () {
            if (postcode) {
                return {
                    status: true,
                    message: "Postcode data found",
                    payload: { postcode: "2122", locality: ["Eastwood, Marsfield"], state: "NSW" },
                };
            }
            return {
                status: true,
                message: "Postcode data not found",
                payload: null,
            };
        });
    }
}
exports.AddressServiceStub = AddressServiceStub;
//# sourceMappingURL=AddressServiceStub.js.map